import { render, staticRenderFns } from "./HiddenComment.vue?vue&type=template&id=2451c083&scoped=true&"
import script from "./HiddenComment.vue?vue&type=script&lang=js&"
export * from "./HiddenComment.vue?vue&type=script&lang=js&"
import style0 from "./HiddenComment.vue?vue&type=style&index=0&id=2451c083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451c083",
  null
  
)

export default component.exports